import { useEffect, useRef, useState } from "react"
import { useParams } from 'react-router';
import { composeImgURL } from "../components/homeGridBlock.component"
import { Collection, CollectionItem } from '../pages/home.page'
import collectionsJson from "../data/collections.json"
import { Link } from "react-router-dom";
import placeholder from "../assets/images/placeholder.jpg"


export function CollectionPage() {
    const { slug } = useParams();
    const [collection, setCollection] = useState<Collection>();
    const [lbImages, setLbImages] = useState<string[]>();
    const [targetIDX, setTargetIDX] = useState<string | null>(null);

    useEffect(() => {
        let collection = (collectionsJson as Collection[]).find((c: Collection) => c.shortName === slug)
        setCollection(collection);
        let img_urls: string[] = []
        collection?.collectionData.forEach((cd: CollectionItem) => {
            img_urls.push(...cd.images)
        });
        setLbImages(img_urls)
    }, [slug])


    return (
        <>
        { (lbImages && collection?.folder) && <LightBox urls={lbImages} folder={collection?.folder} target={targetIDX} /> }

        <div className="row g-0">
            <div className="col-12 col-md-4 offset-md-4 mt-2 p-3 text-center">
                <h2>Collections</h2>
                <p>
                    Paola Quadretti engineers a world of fashion made of sheer
                    elegance, born from her imagination and ingenuity.
                    Every piece architected by Paola Quadretti is created using
                    traditional methods of the greatest “créateurs de mode”
                    hand sewn, handcrafted, handmade, all in her atelier
                    in Florence’s Palazzo Capponi delle Rovinate.
                </p>
                <div className="d-flex flex-wrap justify-content-around">
                    {
                        (collectionsJson as Collection[]).map((c: Collection) => {
                            if (c.link) {
                                return (
                                    <div key={c.shortName}>
                                        <a className="collection-link" rel="noreferrer" href={c.link} target="_blank">{c.shortName}</a>
                                    </div>
                                )
                            } else if (c.addToCollectionMenu) {
                                return (
                                    <div key={c.shortName}>
                                        <Link className="collection-link" to={"/collection/" + c.shortName }>{c.shortName}</Link>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        </div>
        <div className="row g-0">
            <div className="col-12 py-3 px-4 bt">
                <h3 className="mb-0">{collection?.name}</h3>
                {
                    (collection?.photoBook !== "") && (
                        <p className="mb-0 mt-2">
                            <a 
                            className="text-decoration-none text-dark" 
                            style={{fontSize: "16px"}}
                            href={'../books/' + collection?.photoBook} target="_blank" rel="noreferrer">Open the photobook</a>
                        </p>
                    )
                }
            </div>
        </div>
        <div className="row g-0 bt">
            {
                collection?.collectionData.map((item: CollectionItem, idx) => {
                    return (
                        <CollectionItemComponent
                        key={idx}
                        title={item.title}
                        folder={collection.folder}
                        images={item.images} 
                        setTargetIDX={setTargetIDX}
                        />
                    )
                })
            }
        </div>
        <div className="row g-0"></div>
        </>
    )
}

type CollectionItemComponentProps = {
    images: string[],
    folder: string,
    title: string,
    setTargetIDX: (t: string) => void
}

function CollectionItemComponent(props: CollectionItemComponentProps) {
    const [images, setImages] = useState<string[]>([])
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        setImages(props.images);
        setIdx(0);
    }, [props])

    return (
        <div className="col-12 col-md-3 border-col">
            {
                (props.images.length > 1) ? (
                    <div className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner" onClick={(e) => props.setTargetIDX(images[idx])}>
                            {
                                props.images.map((i: string) => {
                                    return (
                                        <div key={i} className={"carousel-item" + ((idx % images.length === images.indexOf(i)) ? " active" : "" )} style={{border: "none"}}>
                                            <img className="d-block w-100" src={'../' + composeImgURL(props.folder, i)} alt="" />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <button className="carousel-control-prev" onClick={(e) => setIdx(idx - 1)} type="button">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" onClick={(e) => setIdx(idx + 1)} type="button">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                ) : (
                        <img 
                            onClick={(e) => props.setTargetIDX(images[idx])}
                            className="img-fluid" style={{width: "100%"}}
                            src={'../' + composeImgURL(props.folder, props.images[0])}
                            alt=""
                        />
                )
            }
            {
                (props.title && props.title !== "") && (
                    <div className="p-3 bt">
                        <p className="mb-0" style={{fontSize: "20px"}}>{props.title}</p>
                    </div>
                )
            }
        </div>
    )
}

interface LightBoxProps {
    urls: string[],
    folder: string,
    target?: string | null
}

export function LightBox(props: LightBoxProps) {
    const [images, setImages] = useState<string[]>(props.urls);
    const [idx, setIdx] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        if (props.target !== null) {
            let i = images.findIndex((i: string) => i === props.target)
            if (i >= 0) {
                setIdx(i);
                setIsOpen(true);
            }
        }
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [props.target])

    function setNextImage() {
        if (idx + 1 === images.length) setIdx(0);
        else setIdx(idx + 1);
    }

    function setPrevImage() {
        if (idx - 1 === 0) setIdx(images.length - 1)
        else setIdx(idx - 1)
    }

    return (
        <div className="modal fade show" tabIndex={-1} role="dialog" style={{display: isOpen ? "block" : "none"}}>
            <div className="modal-dialog modal-dialog-centered">
                <div ref={ref} className="modal-content">
                    <div className="carousel slide">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src={'../' + composeImgURL(props.folder, images[idx])} className="d-block w-100" alt=""/>
                                <div onClick={() => setIsOpen(false)} className="bg-white text-center close-div d-block d-sm-none">
                                    <b>close</b>
                                </div>
                            </div>
                        </div>
                        <button onClick={setPrevImage} className="carousel-control-prev" type="button">
                            <span className="carousel-control-prev-icon"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button onClick={setNextImage} className="carousel-control-next" type="button">
                            <span className="carousel-control-next-icon"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}